import { render, staticRenderFns } from "./TableSort.vue?vue&type=template&id=4188c780&scoped=true&"
import script from "./TableSort.vue?vue&type=script&lang=js&"
export * from "./TableSort.vue?vue&type=script&lang=js&"
import style0 from "./TableSort.vue?vue&type=style&index=0&id=4188c780&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4188c780",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VSelect,VSpacer})
